import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'
import { ZoomApiInterface } from '../types/event-interface'

export function useCheckZoomIntegration() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ZoomApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, isLoading, mutate } = useSWR(() => {
    if (user) {
      return `/api/dashboard/booking-calendar/zoom/integrations?timezone=${user.timezone}`
    }
  }, fetcher)

  return { isZoomIntegrated: Boolean(data?.items.length), isLoading, mutate }
}
